<p-button 
    icon="fas fa-trash"
    [rounded]="true"
    [text]="true"
    [pTooltip]="l('::Delete')"
    tooltipPosition="left"
    (onClick)="onClick()" />